import get from "lodash/get";

export const FloodlightActivities = {
  enable() {},
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "DC-10031883");
  },
  wait() {
    return !!window.gtag;
  },
  landing() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin003+standard"
    });
  },
  oferta() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin008+standard"
    });
  },
  ofertaCA() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin004+standard"
    });
  },
  sucursal() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin005+standard"
    });
  },
  paso1() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin009+standard"
    });
  },
  paso2() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin00-+standard"
    });
  },
  paso3() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin00a+standard"
    });
  },
  paso4() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin00b+standard"
    });
  },
  thankYou(context) {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u1: get(context, "state.dataOferta.nroDeTramite", ""),
      u2: get(context, "state.dataOferta.oferta.numeroCliente", ""),
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin00c+standard"
    });
  },
  thankYouCA(context) {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u1: get(context, "state.dataOferta.nroDeTramite", ""),
      u2: get(context, "state.dataOferta.oferta.numeroCliente", ""),
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin006+standard"
    });
  },
  cliente(context) {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u1: get(context, "state.dataOferta.nroDeTramite", ""),
      u2: get(context, "state.dataOferta.oferta.numeroCliente", ""),
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/nomin0/nomin00d+standard"
    });
  }
};

export default FloodlightActivities;
